import type { DailyStepRepository } from '../../../application/ports/DailyStepRepository';
import type { DailyStep } from '../../../domain/routine/models';
import type { DailyRoutineId, DailyStepId } from '../../../domain/shared/ids';
import type { AscendInvictusDatabase } from '../AscendInvictusDatabase';
import { DailyStepMapper } from '../mappers';
import { executePersistence } from '../translatePersistenceError';

export class DexieDailyStepRepository implements DailyStepRepository {
  public constructor(private readonly database: AscendInvictusDatabase) {}

  public save(step: DailyStep): Promise<void> {
    return executePersistence('write', async () => {
      await this.database.dailySteps.put(DailyStepMapper.toRecord(step));
    });
  }

  public findById(id: DailyStepId): Promise<DailyStep | null> {
    return executePersistence('read', async () => {
      const record = await this.database.dailySteps.get(id);
      return record ? DailyStepMapper.fromRecord(record) : null;
    });
  }

  public listByRoutine(dailyRoutineId: DailyRoutineId): Promise<readonly DailyStep[]> {
    return executePersistence('read', async () => {
      const records = await this.database.dailySteps
        .where('dailyRoutineId')
        .equals(dailyRoutineId)
        .sortBy('order');
      return records.map((record) => DailyStepMapper.fromRecord(record));
    });
  }

  public delete(id: DailyStepId): Promise<void> {
    return executePersistence('write', async () => {
      await this.database.dailySteps.delete(id);
    });
  }
}
